export default "__VITE_ASSET__ysIG3YvL__"